;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

const ContactContext = React.createContext({
    animationState: '',
    timingBase: 0,
    contactReason: null,
    activeStep: 0,
    stepsLength: 0,
    steps: [],
    gridConfig: [],
    setContactReason: () => {},
    setActiveStep: () => {},
    handleReset: () => {},
});

export default ContactContext;
